import axios from 'axios'
import config from '@/config'

const closeupService = {
  adminCloseupUpdate(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/admin/candidate/update`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  adminCloseupUpload(context, formData) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: formData,
        url: config.BASE_API_URL_V2 + `/closeup/admin/upload`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  adminCloseupUploadSinglePage(context, formData) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: formData,
        url: config.BASE_API_URL_V2 + `/closeup/admin/upload/pages`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  adminCloseupDeleteSinglePage(context, formData) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: formData,
        url: config.BASE_API_URL_V2 + `/closeup/admin/delete/pages`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  adminCloseupDelete(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/admin/delete`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  candidateCloseupUploadPages(context, formData) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: formData,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/upload/pages`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateCandidateCloseupCount(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/profile/candidate/findbyid?candidate_id=${data.id}&closeup=true`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => console.log('count error', e))
    })
  },
  updateCloseupWatchTime(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + '/closeup/candidate/time/tracking',
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  getCloseupWatchTime(context, email) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/closeup/candidate/view/time?candidateEmail=${email}`,
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  candidateCloseupUpload(context, formData) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: formData,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/upload`,
        onUploadProgress: function (progressEvent) {
          console.log(progressEvent)
          context.commit(
            'closeupVideoUploadProgess',
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          )
          if (progressEvent.loaded === progressEvent.total) {
            setTimeout(() => {
              context.commit('closeupVideoUploadProgess', 0)
            }, 3000)
          }
        },
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  evaluatePrecire(context, data) {
    console.log('data: ', data)
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/evaluation`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  candidateCloseupDelete(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/delete`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  upgradeCloseup(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + '/closeup/candidate/upload',
      })
        .then(res => {
          console.log('CU Upgraded', res.data)
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  createPayPalPaymentResource(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/shop/createpayment`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updatePayPalPayment(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/shop/updatepayment`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  executePayPalPayment(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_URL_V2 + `/closeup/candidate/shop/executepayment`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  verifyVoucher(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/closeup/candidate/shop/voucher?voucherCode=${data.voucherCode}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  // getPayPalPaymentResource(context, data) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'GET',
  //       url: config.BASE_API_URL_V2 + `/closeup/candidate/shop/createpayment`
  //     })
  //       .then(response => {
  //         resolve(response.data)
  //       }).catch(e => {
  //         reject(e.response)
  //       })
  //   })
  // }
}
export default closeupService
